import React from 'react';
import classNames from 'classnames';
import './demographics.scss';

const Demographics = ({ demographics, heading, modifiers, smallLabel = false }) => {

    if (!demographics) return null;
    
    const calcPercent = (value) => {
        return (value / demographics.total) * 100;
    };

    return (
        <section className={classNames({
            'demographics': true,
            ...modifiers
        })}>
            {heading &&
                <h2 className="demographics__heading">{heading}</h2>
            }

            {smallLabel &&
                <h2 className="demographics__heading">{demographics.total.toLocaleString('sv')} <span>invånare</span></h2>
            }

            <div className="demographics__graph-container">
                {!smallLabel && demographics.dataItems.map(gender => {
                    return (
                        <div className="demographics__graph-label">
                            <h3 className="demographics__graph-label-heading">{gender.title}</h3>
                            <span className="demographics__graph-label-text">{gender.value.toLocaleString('sv')} st</span>
                        </div>
                    );
                })}
                <div className="demographics__graph-bar-outer-container">
                    <div className="demographics__graph-bar-container">
                        {demographics.dataItems.map(gender => {
                            return (
                                <div className={classNames({
                                    'demographics__graph-bar': true,
                                    'demographics__graph-bar--w': gender.title.indexOf('kvinnor') > -1,
                                    'demographics__graph-bar--m': gender.title.indexOf('män') > -1,
                                })} style={{
                                    width: `${calcPercent(gender.value)}%`
                                }}>{calcPercent(gender.value).toFixed(1)}%</div>
                            );
                        })}
                    </div>
                </div>
                {smallLabel && demographics.dataItems.map(gender => {
                    return (
                        <div className="demographics__graph-label" style={{
                            width: `${calcPercent(gender.value)}%`
                        }}>
                            <span className="demographics__graph-label-text">{gender.value.toLocaleString('sv')} {gender.title.replace('Antal', '')}</span>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default Demographics;